import { ChevronsLeft, ChevronsRight } from 'lucide-react';

interface PanelWidthToggleProps {
  wide: boolean;
  onToggle: () => void;
}

// The side panel's width control, as a header icon beside Clear and Close.
//
// It used to sit in a strip of its own above the panel, on the far right of an
// otherwise empty row — the only control on the screen not grouped with its
// siblings, and a row of vertical space spent on one button. Instructor: "icon
// for wider should be beside delete icon". It is the same kind of thing as
// Clear and Close — something you do TO the panel rather than with it — so it
// belongs in the same cluster.
//
// Rendered only at lg and up. Below that the panel is already a full-screen
// overlay, so there is nothing to widen and the control would be a lie.
export default function PanelWidthToggle({ wide, onToggle }: PanelWidthToggleProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={wide}
      // Matches the size/shape of the Clear and Close buttons it now sits with.
      className="hidden size-7 place-items-center rounded-md text-ws-ink-3 transition-colors hover:bg-ws-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ws-accent lg:grid"
      title={wide ? 'Narrow this panel' : 'Widen this panel (2x)'}
      aria-label={wide ? 'Narrow the panel' : 'Widen the panel to double width'}
    >
      {wide ? <ChevronsRight size={15} /> : <ChevronsLeft size={15} />}
    </button>
  );
}
